import { Link } from "gatsby";
import React from "react";
import { OptionText } from "./QueTexts";

export function RadioBox({
  title,
  isSelected,
  onChange,
  value,
  to,
  icon,
  ref,
}) {
  return (
    <Link className="que-animation-stagger" ref={ref} to={to}>
      <label className="que-radio">
        <input
          type="radio"
          name="radio"
          value={value}
          checked={isSelected}
          onChange={onChange}
        />
        <div className="que-radio-btn">
          <div className="que-option-svg">{icon}</div>
          <div className="que-option-title">
            <OptionText>{title}</OptionText>
          </div>
        </div>
      </label>
    </Link>
  );
}
export function SmallRadioBox({
  title,
  isSelected,
  onChange,
  value,
  to,
  icon,
  ref,
}) {
  return (
    <Link className="que-small-animation-stagger" ref={ref} to={to}>
      <label className="que-small">
        <input
          type="radio"
          name="radio"
          value={value}
          checked={isSelected}
          onChange={onChange}
        />
        <div className="que-small-btn">
          <div className="que-small-option-svg">{icon}</div>
          <div className="que-small-option-title">
            <OptionText>{title}</OptionText>
          </div>
        </div>
      </label>
    </Link>
  );
}
export function CheckBox({
  title,
  isSelected,
  onChange,
  value,
  to,
  icon,
  ref,
}) {
  return (
    <Link className="que-check-animation-stagger" ref={ref} to={to}>
      <label className="que-check">
        <input
          type="checkbox"
          name="checkbox"
          value={value}
          checked={isSelected}
          onChange={onChange}
        />
        <div className="que-check-btn">
          <div className="que-check-option-svg">{icon}</div>
          <div className="que-check-option-title">
            <OptionText>{title}</OptionText>
          </div>
        </div>
      </label>
    </Link>
  );
}
